<template>
  <section>
    <div v-if="loadingStatus">
      <ContentLoader :size="4"></ContentLoader>
    </div>
    <div
      class="grid md:grid-cols-3 lg:grid-cols-4 grid-cols-1 bg-white rounded-lg"
      v-else
    >
      <div
        v-for="(d, i) in data"
        :key="i"
        class="bg-white border-1 border-borderColor rounded-lg m-1 duration-500 shadow-all"
      >
        <router-link
          :to="{
            name: 'session',
            params: { id: d.session_id },
            query: {
              activity: true,
            },
          }"
        >
          <Tooltip
            trigger="hover"
            :options="{
              placement: 'bottom',
              modifiers: { offset: { offset: '0,2px' } },
            }"
          >
            <div
              class="flex shadow h-full p-2 items-center"
              slot="reference"
            >
              <img
                class="object-cover h-20 w-20 rounded"
                :src="baseUrlSrc(d.thumbnail_url)"
                alt="..."
                @error="defaultImage"
              />
              <div class="px-2 flex-1">
                <h5 class="captalize text-base font-semibold text-blackgrey mb-1">
                  {{ handleStr(d.title, 30) }}
                </h5>
                <p class="text-gray-light text-xs mb-1">
                  {{ getFormattedDate(d.start_date, d.timezone, 'MMM DD, YYYY (ddd)') }}
                </p>
                <p class="text-gray-light text-xs">
                  {{ getFormattedDate(d.start_date, d.timezone, 'h:mm A') }} -
                  {{ getFormattedDate(d.end_date, d.timezone, 'h:mm A') }}
                </p>
              </div>
            </div>
            <span v-if="d.course_id != null" class="popper"
              >Class Pack: {{ handleStr(d.course_title, 40) }}</span
            >
          </Tooltip>
        </router-link>
      </div>
    </div>
    <div v-if="statusCode == 404">
      <p>No data found.</p>
    </div>
  </section>
</template>

<script>
import ContentLoader from "@/components/vue-spinner/ContentLoader";
import Tooltip from "@/components/Tooltip.vue";

export default {
  name: "UpcomingSessionCard",
  components: {
    ContentLoader,
    Tooltip,
  },
  props: {
    data: {
      type: Array,
    },
    statusCode: {
      type: Number,
    },
  },
  computed: {
    loadingStatus() {
      return this.$store.getters.loadingStatus;
    },
  },
};
</script>